export function datetimeFormatter(time = new Date(), utc = "+8") {
    try {
      // 處理 utc 參數
      let utcOffset;
      if (typeof utc === 'string') {
        utcOffset = parseInt(utc.replace(/[^-+\d]/g, ''));
      } else {
        utcOffset = Number(utc);
      }
      
      if (isNaN(utcOffset)) {
        throw new Error('Invalid UTC offset');
      }
      
      // 處理時間參數
      let utcTime;
      if (typeof time === 'string') {
        const dateObj = new Date(time);
        if (isNaN(dateObj.getTime())) {
          throw new Error('Invalid date string');
        }
        utcTime = dateObj.getTime();
      } else if (time instanceof Date) {
        utcTime = time.getTime();
      } else {
        throw new Error('Invalid time parameter');
      }
      
      // 計算目標時區的時間戳記
      const targetTime = utcTime + (utcOffset * 60 * 60 * 1000);
      const targetDate = new Date(targetTime);
      
      // 使用你建議的方法：將 Date 物件轉為字串再擷取
      const targetDateStr = String(targetDate);
      
      // 解析字串格式：Fri Jun 20 2025 14:28:29 GMT+0800 (台北標準時間)
      // 使用正則表達式擷取日期和時間部分
      const dateTimeRegex = /(\w{3})\s+(\w{3})\s+(\d{1,2})\s+(\d{4})\s+(\d{2}):(\d{2}):(\d{2})/;
      const match = targetDateStr.match(dateTimeRegex);
      
      if (!match) {
        throw new Error('Unable to parse date string format');
      }
      
      const [, dayOfWeek, monthName, day, year, hours, minutes, seconds] = match;
      
      // 月份名稱對應數字
      const monthMap = {
        'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04',
        'May': '05', 'Jun': '06', 'Jul': '07', 'Aug': '08',
        'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12'
      };
      
      const month = monthMap[monthName];
      if (!month) {
        throw new Error(`Unknown month: ${monthName}`);
      }
      
      // 格式化日期（補零）
      const dayFormatted = day.padStart(2, '0');
      
      return `${year}/${month}/${dayFormatted} ${hours}:${minutes}:${seconds}`;
      
    } catch (error) {
      console.error('DateTime formatting error:', error.message);
      return null;
    }
  }